import {SortColumnNames} from "../components/MonthlyTableColumns";
import {
    MONTHLY_MONTHS_UPDATE,
    MONTHLY_WORK_CHECK_CLEAR,
    MONTHLY_WORK_CHECK_ERROR,
    MONTHLY_WORK_CHECK_LOADING,
    MONTHLY_WORK_CHECK_SORT,
    MONTHLY_WORK_CHECK_STATES_UPDATE,
    MONTHLY_WORK_CHECK_TYPES_UPDATE,
    MONTHLY_WORK_CHECK_UPDATE,
    MONTHLY_WORK_STATE_MONTH_UPDATE,
    MONTHLY_YEARS_UPDATE
} from "../actions/monthlyActions";
import { Compare } from '../../../shared/compare/Compare';

const INITIAL_STATE = {
    workers: {},
    workersSorted: [],
    dayChecksByWorker: {},
    monthChecksByWorker: {},
    monthlyPagination: null,
    monthlyLoading: false,
    monthlyError: null,
    days: [],
    workCheckStates: [],
    workCheckTypes: [],
    years: [],
    months: [],
    columnSortedSelected: SortColumnNames.WORKER_DNI,
    columnSortAsc: {
        [SortColumnNames.WORKER_DNI]: true,
        [SortColumnNames.WORKER_NAME]: true,
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MONTHLY_WORK_CHECK_UPDATE:
            const initialSort = {
                orderBy: state.columnSortedSelected,
                asc: state.columnSortAsc[state.columnSortedSelected],
            };

            return {
                ...state,
                monthlyPagination: action.payload.pagination,
                monthlyError: action.payload.message,
                days: action.payload.data.days,
                dayChecksByWorker: action.payload.data.dayChecksByWorker,
                monthChecksByWorker: action.payload.data.monthChecksByWorker,
                workers: action.payload.data.workers,
                workersSorted: sortWorkers(action.payload.data.workers, initialSort),
                workCheckTypes: action.payload.data.documentTypes
            };
        case MONTHLY_WORK_CHECK_SORT:
            const columnSortedSelected = action.payload;
            const columnSortAsc = {
                ...state.columnSortAsc,
                [columnSortedSelected]: !state.columnSortAsc[columnSortedSelected],
            };

            const sort = {
                orderBy: columnSortedSelected,
                asc: columnSortAsc[columnSortedSelected],
            };

            return {
                ...state,
                workersSorted: sortWorkers(state.workers, sort),
                columnSortedSelected,
                columnSortAsc
            };
        case MONTHLY_WORK_CHECK_CLEAR:
            return {
                ...state,
                monthlyPagination: null,
                days: [],
            };
        case MONTHLY_WORK_CHECK_ERROR:
            return {...state, monthlyError: action.payload};
        case MONTHLY_WORK_CHECK_LOADING:
            return {...state, monthlyLoading: action.payload};
        case MONTHLY_YEARS_UPDATE:
            const newYears = action.payload.data.map((year) => {
                return {
                    value: year,
                    name: year,
                };
            });
            return {...state, years: newYears};
        case MONTHLY_MONTHS_UPDATE:
            return {...state, months: action.payload.data};
        case MONTHLY_WORK_CHECK_STATES_UPDATE:
            return {...state, workCheckStates: action.payload.data};
        case MONTHLY_WORK_CHECK_TYPES_UPDATE:
            return {...state, workCheckTypes: action.payload.data};
        case MONTHLY_WORK_STATE_MONTH_UPDATE:
            const newMonthChecksByWorker = {...state.monthChecksByWorker};

            let workerMonthChecks = newMonthChecksByWorker[action.workerId];
            if (!workerMonthChecks) {
                workerMonthChecks = [];
                workerMonthChecks.push(action.payload)
            } else {
                let update = false;
                for (let i = 0; i < workerMonthChecks.length; i++) {
                    const workerMonthCheck = workerMonthChecks[i];
                    if (workerMonthCheck.document_type_id === action.payload.document_type_id) {
                        workerMonthChecks[i].worker_check_state_id = parseInt(action.payload.worker_check_state_id, 0);
                        update = true;
                        break
                    }
                }
                if (!update) {
                    workerMonthChecks.push(action.payload)
                }
            }

            newMonthChecksByWorker[action.workerId] = workerMonthChecks;

            return {...state, monthChecksByWorker: newMonthChecksByWorker};
        default:
            return state;
    }
};

const sortWorkers = (workers, sort) => {
    const {orderBy, asc} = sort;

    let compareFn;
    switch (orderBy) {
        case SortColumnNames.WORKER_DNI:
            compareFn = (workerA, workerB) => {
                const dniA = workerA.dni;
                const dniB = workerB.dni;
                return Compare.compareStrings(dniA, dniB, asc);
            };
            break;
        case SortColumnNames.WORKER_NAME:
            compareFn = (workerA, workerB) => {
                const completeNameA = `${workerA.name} ${workerA.last_name}`;
                const completeNameB = `${workerB.name} ${workerB.last_name}`;
                return Compare.compareStrings(completeNameA, completeNameB, asc);
            };
            break;
        default:
            compareFn = () => false;
    }

    return Object
        .entries(workers)
        .map(([workerKey, worker]) => ({...worker, id: workerKey}))
        .sort(compareFn);
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/reducer/MonthlyReducer.js